import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const useWizardRouterHistory = () => {
	const history = useHistory()
	const location = useLocation()

	const queryParams = useMemo(() => {
		const { search } = location
		return new URLSearchParams(search)
	}, [location])

	// removing logic from this for now, otherwise it adds step=#
	const setStepInHistory = useCallback(
		(step) => {
			return
			// const { pathname } = location
			// queryParams.set('step', step)
			// const updatedUrl = `${pathname}?${queryParams.toString()}`
			// history.replace(updatedUrl)
		},
		[history, location, queryParams]
	)

	const clearHistory = useCallback(() => {
		const { pathname } = location
		const updatedUrl = `${pathname}`
		history.replace(updatedUrl)
	}, [history, location, queryParams])

	const goToNewGroomingAppointmentView = useCallback(
		({ facilityId, housholdId, petId }) => {
			if (!facilityId) {
				return
			}
			history.push(
				`/facilities/${facilityId}/appointment/create?type=grooming&household=${housholdId}&pet_id=${petId}`
			)
		},
		[history]
	)

	return { history, setStepInHistory, clearHistory, goToNewGroomingAppointmentView }
}

export default useWizardRouterHistory
